<template>
  <div class="form-control" >
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{ 'text-danger': current.errors && current.errors.usuario }"
      >{{ titulo }}</label
    >
    <v-select
      label="name"
      v-model="current.usuario"
      :filterable="false"
      :options="users.results"
      @search="onSearch"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onChange($event)"
    >
      <template slot="no-options">usuarios...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.username }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.username }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.usuario"
      class="form-text text-danger"
      >{{ current.errors.usuario }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    autouser: {
      type: Boolean,
      required: false,
      default: false,
    },
    titulo: {
      type: String,
      default: "Usuario",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      users: "accounts/users",
    }),
  },
  mounted() {
    this.$store.dispatch("accounts/users", {
      page: 1,
    });
    let self = this;
    if (self.current.estado == undefined) {
      self.current.estado = "A";
    }
    if (self.autouser == true) {
      alert("");
    }
  },
  methods: {
    onChange(event) {
      this.$emit("onChange", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("accounts/users", {
        activo: true,
        page: 1,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>